
class DiscountPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

    this.delay = parseInt(this.getAttribute('delay') || '5000', 10);
    this.closeBtn = this.dialog.querySelector('.discount-popup__close');
    console.log(this.closeBtn);
    
    this.storage = (this.getAttribute('storage') || 'session').toLowerCase();
    this.key = this.getAttribute('key') || 'discount_popup_closed_session';
    this.store = this.storage === 'local' ? localStorage : sessionStorage;

    if (this.store.getItem(this.key)) return;

    this.timer = setTimeout(() => {
      if (!this.dialog.open) this.dialog.showModal();
    }, this.delay);

    this._onBackdrop = (e) => { if (e.target === this.dialog) this.dialog.close(); };
    this._onClose = () => { this.store.setItem(this.key, 'true'); };
    this._onCta = () => { this.store.setItem(this.key, 'true'); if (this.dialog.open) this.dialog.close(); };
    
    this.closeBtn.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', this._onBackdrop);
    this.dialog.addEventListener('close', this._onClose);
    this.querySelectorAll('.js-discount-cta').forEach(el => el.addEventListener('click', this._onCta));
  }

  disconnectedCallback() {
    if (this.timer) clearTimeout(this.timer);
    if (!this.dialog) return;
    this.dialog.removeEventListener('click', this._onBackdrop);
    this.dialog.removeEventListener('close', this._onClose);
    this.querySelectorAll('.js-discount-cta').forEach(el => el.removeEventListener('click', this._onCta));
  }
}
customElements.define('discount-popup', DiscountPopup);

